import React from "react";
import Label from "components/general/Label"
import DateTime from "components/presentation/DateTime"
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import Noc from "components/presentation/Noc";
import Competitor from "components/presentation/Competitor";
import Status from "components/presentation/Status";
import { getDateTimeFormat } from "helpers/utils";


export function CompetitorBlock(competitor) {

    let seed = ''
    let competitorBracket;
    if (competitor.co_seed) {
        seed = '(' + competitor.co_seed + ')'
    }
    if (competitor?.participant?.__typename === 'Person') {
        competitorBracket = <div className="w-85"><Competitor  {...competitor?.participant} hideNoc={true} hidePicture={true} noLink={true} onlyShortName={true} screen={competitor.screen} /></div>
    } else {
        competitorBracket = <div className="w-85"><Competitor hidePicture={true} hideNoc={true} noLink={true} teamAthletes={competitor?.resultItem?.teamAthletes} onlyShortName={true} screen={competitor.screen} /></div>
    }

    //Check if the game is singles or doubles

    return (
        <div className='score-competitor-container d-flex justify-content-start text-truncate'>
            <div className='score-noc'>
                <Noc className='me-1' {...competitor?.participant?.organisation} />
            </div>
            <div className='score-name d-flex align-items-center'>
                {competitorBracket}
                <span><sup>{seed}</sup></span>
            </div>
        </div>
    )
}

export function Footer({ data }) {
    const formatDate = getDateTimeFormat('DayMonthShort')
    const formatDateTime = getDateTimeFormat('DayMonthShortHourMinute');

    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} /></>
    const dateComponent = data?.bi_time ? dateTimeFormated : date

    //console.log(data)
    return (
        <>
            {isLiveStatus(data?.result?.status?.code) && <div className='score-status justify-content-end'>
                <Status typeToPrint={'result'} scheduleStatus={data?.schedule?.status?.code} resultStatus={data?.result?.status?.code} />
            </div>}
            {isLessLiveStatus(data?.result?.status?.code) && <div className='row w-100'><div className='text-start col'>{dateComponent}</div><div className='text-end col'>{data?.schedule?.location?.shortDescription}</div></div>}
        </>
    )
}